import request from '@/utils/request'

const apis = {
    startStudy: '/api/v1/startStudy',
    studyHour: '/api/v1/studyHour',
    endStudy: '/api/v1/endStudy',
    getFaceCompareConfig: '/api/v1/getFaceCompareConfig',
    thirdFaceCompare: '/api/v1/thirdFaceCompare',
    submitRecordVideoUrl: '/api/v1/submitRecordVideoUrl',
}

var headers = {
    'Content-Type': 'application/json'
}
export default {
/*    var param = {
        "userCode": userCode,
        "groupCode": groupCode,
        "courseCode": courseCode,
        "lessonCode": lessonCode,
        "vodCode" : vodCode
    }*/
    // 开始学习
    startStudy (data) {
        let dt = data || {};
        return request.post(apis.startStudy, JSON.stringify(dt.params), {headers: headers || {}});
    },
/*    var param = {
        "userCode": userCode,
        "groupCode": groupCode,
        "courseCode": courseCode,
        "lessonCode": lessonCode,
        "vodCode" : vodCode
    }*/
    // 结束学习
    endStudy(data) {
        let dt = data || {};
        return request.post(apis.endStudy, JSON.stringify(dt.params), {headers: headers || {}});
    },
/*    var param = {

        "lessonCode": lessonCode,
        "playTime" : playTime,   // 当前播放时长（秒）
        "progressTime" : progressTime, // 距离上次增量多少（秒）
        "userCode": userCode,
        "groupCode": groupCode,
        "courseCode": courseCode,
        "vodCode" : vodCode
    }*/
    // 进度上报
    studyHour(data) {
        let dt = data || {};
        return request.post(apis.studyHour, JSON.stringify(dt.params), {headers: headers || {}});
    },
    // 获取监管配置
/*    var param = {
        "userCode": userCode,
        "groupCode": groupCode,
        "courseCode": courseCode,
        "lessonCode": lessonCode,
        "vodCode" : vodCode
    }*/
    getFaceCompareConfig(data) {
        let dt = data || {};
        return request.post(apis.getFaceCompareConfig, JSON.stringify(dt.params), {headers: headers || {}});
    },
  /*  var param = {
        "target": target,      //人脸上传地址
        "compareMode": compareMode, //默认0
        "faceCompareResult": faceCompareResult, //  1 通过  2不通过
        "userCode": userCode,
        "groupCode": groupCode,
        "courseCode": courseCode,
        "lessonCode": lessonCode,
        "vodCode" : vodCode,
        "videoStudyTime" : videoStudyTime,  //人脸识别的位置
        "bizCode" : bizCode,  // 回签  ，通过getFaceCompareConfig 接口获取
    }*/
    // 提交人脸识别突破记录
    thirdFaceCompare(data) {
        let dt = data || {};
        return request.post(apis.thirdFaceCompare, JSON.stringify(dt.params), {headers: headers || {}});
    },

    /*    var param = {
        "userCode": userCode,
        "groupCode": groupCode,
        "courseCode": courseCode,
        "lessonCode": lessonCode,
        "vodCode" : vodCode,
        "recordVideoUrl" : recordVideoUrl  // 视频录制的地址
    }*/
    // 提交视频录制接口
    submitRecordVideoUrl(data) {
        let dt = data || {};
        return request.post(apis.submitRecordVideoUrl, JSON.stringify(dt.params), {headers: headers || {}});
    },
}
// WEBPACK FOOTER //
// ./src/api/info.js



// WEBPACK FOOTER //
// ./src/api/hebeiSDK.js